import { DoctorClickedEvent } from './DoctorClicked'
import { DoctorPageViewedEvent } from './DoctorPageViewed'
import { DoctorViewedEvent } from './DoctorViewed'
import { HospitalClickedEvent } from './HospitalClicked'
import { HospitalPageViewedEvent } from './HospitalPageViewed'
import { HospitalViewedEvent } from './HosptialViewed'
import { ServiceOfferClickedEvent } from './ServiceOfferClicked'
import { ServiceOfferPageViewedEvent } from './ServiceOfferPageViewed'
import { ServiceOfferViewedEvent } from './ServiceOfferViewed'

export interface Event<Name, Body> {
  TraceId: string
  Timestamp: number
  Name: Name
  Body: Body
}

export interface DefaultEventBody {
  hospitalId: number
  fromWebView: boolean
  deviceId: string
  userId: number
  platform: Platform
  appVersion: string
  pageName: PageName
}

export enum Platform {
  Android = 'ANDROID',
  IOS = 'iOS',
  Web = 'WEB',
}

export enum EventName {
  AdViewed = 'AdViewed',
  AdClicked = 'AdClicked',
  ServiceOfferViewed = 'ServiceOfferViewed',
  ServiceOfferPageViewed = 'ServiceOfferPageViewed',
  ServiceOfferClicked = 'ServiceOfferClicked',
  HospitalViewed = 'HospitalViewed',
  HospitalClicked = 'HospitalClicked',
  HospitalPageViewed = 'HospitalPageViewed',
  DoctorPageViewed = 'DoctorPageViewed',
  DoctorClicked = 'DoctorClicked',
  DoctorViewed = 'DoctorViewed',
}

export enum PageName {
  SearchTotalWeb = 'search_total_web',
  EventTotalWeb = 'event_total_web',
  EventDetail = 'event_detail',
  EventDetailWeb = 'event_detail_web',
  HospitalListWeb = 'hospital_list_web',
  HospitalDetail = 'hospital_detail',
  HospitalDetailWeb = 'hospital_detail_web',
  HospitalDetailEventTab = 'hospital_detail_event_tab',
  HospitalDetailTreatmentCaseTab = 'hospital_detail_treatment_case_tab',
  DoctorDetail = 'doctor_detail',
  DoctorDetailWeb = 'doctor_detail_web',
  CommunityDetail = 'community_detail',
  ConsultationComplete = 'consultation_complete',
  WaitingReservationComplete = 'waiting_reservation_complete',
  ImmediateReservationComplete = 'immediate_reservation_complete',
  PurchaseComplete = 'purchase_complete',
  WaitingReservationPurchaseComplete = 'waiting_reservation_purchase_complete',
  ImmediateReservationPurchaseComplete = 'immediate_reservation_purchase_complete',
  EventDetailRelatedServiceOfferAfterZzim = 'event_detail_related_service_offer_after_zzim',
  ReservationDetailSelectedServiceOffer = 'reservation_detail_selected_service_offer',
  ConsultationStatusDetail = 'consultation_status_detail',
  CHAT_DETAIL = 'chat_detail',
  // 찜 목록 페이지
  ZZIM_LIST = 'zzim_list',
  ZZIM_LIST_RECOMMENDATION = 'zzim_list_recommendation',
}

export enum Currency {
  KRW = 'KRW',
  JPY = 'JPY',
  USD = 'USD',
  THB = 'THB',
  CNY = 'CNY',
  TWD = 'TWD',
}

export interface Predecessor {
  TraceId: string
  Name: EventName
}

export type CollectableEvent =
  | ServiceOfferViewedEvent
  | ServiceOfferClickedEvent
  | ServiceOfferPageViewedEvent
  | HospitalViewedEvent
  | HospitalClickedEvent
  | HospitalPageViewedEvent
  | DoctorViewedEvent
  | DoctorPageViewedEvent
  | DoctorClickedEvent
